// CAD drawing downloads (PDF / 2D DWG / 3D DWG / STEP), sourced from the
// company's SharePoint CAD library via a Power Automate-maintained data file
// (see JSON Files/CAD/pump-selector-cad-drawings.json for the row template). Matched
// on pump model + motor model since drawings differ by which motor is
// fitted - this applies to booster sets too, since customers can change the
// motor on those as well.
PS.cadFileTypes = [
  { key: 'pdfUrl', label: 'PDF' },
  { key: 'dwg2dUrl', label: '2D DWG' },
  { key: 'dwg3dUrl', label: '3D DWG' },
  { key: 'stepUrl', label: 'STEP' }
];

PS.getCadDrawing = function (match) {
  const rows = PS.cadData?.drawings;

  if (!Array.isArray(rows) || !rows.length) {
    return null;
  }

  const pumpModel = PS.getPumpDisplayName(match);
  const motor = PS.getEffectiveMotor(match);
  const motorModel = motor?.description || null;

  const row = rows.find(r =>
    String(r.pumpModel || '').trim().toLowerCase() === String(pumpModel || '').trim().toLowerCase() &&
    String(r.motorModel || '').trim().toLowerCase() === String(motorModel || '').trim().toLowerCase()
  );

  return row || null;
};

// Browsers won't let JS fetch() the bytes of a cross-origin SharePoint link
// (no CORS), so the files can't be bundled into a zip client-side - instead
// each checked file type triggers its own normal browser download via a
// transient anchor click, staggered slightly so popup/download blockers
// don't swallow anything after the first.
PS.downloadCadFiles = function (drawing, fileKeys) {
  fileKeys.forEach((key, index) => {
    const url = drawing[key];

    if (!url) {
      return;
    }

    setTimeout(() => {
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }, index * 300);
  });
};

PS.wireCadControls = function (targetId, match) {
  const button = document.getElementById(`${targetId}-download-cad`);

  if (!button) {
    return;
  }

  button.addEventListener('click', () => {
    const drawing = PS.getCadDrawing(match);
    const optionsContainer = document.getElementById('cad-download-options');
    const modal = document.getElementById('cad-download-modal');

    if (!drawing || !optionsContainer || !modal) {
      return;
    }

    PS.state.cadDrawing = drawing;

    const optionsHtml = PS.cadFileTypes.map(type => {
      const available = !!drawing[type.key];

      return `
        <label style="display:block; margin-bottom:4px;${available ? '' : ' opacity:0.6;'}">
          <input type="checkbox" data-cad-file="${type.key}" ${available ? 'checked' : 'disabled'}>
          ${type.label}
          ${available ? '' : '<span style="color:#b00020; font-weight:600; margin-left:6px;">Not currently available</span>'}
        </label>
      `;
    }).join('');

    optionsContainer.innerHTML = optionsHtml;
    modal.style.display = 'block';
  });
};

PS.wireCadDownloadModal = function () {
  const modal = document.getElementById('cad-download-modal');

  if (!modal) {
    return;
  }

  document.getElementById('cad-download-go').addEventListener('click', () => {
    const drawing = PS.state.cadDrawing;

    if (!drawing) {
      return;
    }

    const fileKeys = Array.from(document.querySelectorAll('#cad-download-options input[data-cad-file]:checked'))
      .map(input => input.dataset.cadFile);

    PS.downloadCadFiles(drawing, fileKeys);
    modal.style.display = 'none';
  });

  document.getElementById('cad-download-close').addEventListener('click', () => {
    modal.style.display = 'none';
  });
};
